import { Dispatch, SetStateAction, useState } from 'react';
import { Candidate } from 'types';

import { postRejectCandidate } from './services/ModalRejectCandidate';

import HappyFaceSvg from 'App/assets/img/happy-face.svg?url';
import SadFaceSvg from 'App/assets/img/sad-face.svg?url';
import Analytics from 'helpers/analytics';

type useModalRejectCandidateProps = {
	selectedCandidates: Candidate[];
	setSelectedCandidates: Dispatch<SetStateAction<Candidate[]>>;
	setReloadTable: Dispatch<SetStateAction<boolean>>;
	handleClose: () => void;
};

export const useModalRejectCandidate = ({
	selectedCandidates,
	setSelectedCandidates,
	setReloadTable,
	handleClose,
}: useModalRejectCandidateProps) => {
	const [isLoadingRejectCandidate, setLoadingRejectCandidate] =
		useState<boolean>(false);

	const [confirmModal, setConfirmModal] = useState({
		show: false,
		message: '',
		icon: '',
		// eslint-disable-next-line @typescript-eslint/no-empty-function
		onClose: () => {},
	});

	const handleCloseRejectModal = () => {
		setReloadTable(true);
		setSelectedCandidates([]);
		handleClose();
	};

	const handleRejectCandidates = async () => {
		setLoadingRejectCandidate(true);
		try {
			const response = await postRejectCandidate(selectedCandidates);
			if (response.data?.content?.errors.length > 0) {
				let message = '';
				response.data.content.errors.forEach(
					(element: { message: string; candidateId: string }) => {
						if (message === 'Candidate already approved or rejected') {
							message +=
								`El colaborador ya approvado or declinado - ${element.candidateId}` +
								'\n';
						} else {
							message += `${element.message} - ${element.candidateId}` + '\n';
						}
					},
				);
				setConfirmModal({
					show: true,
					message: message,
					icon: SadFaceSvg,
					onClose: handleCloseRejectModal,
				});
			} else {
				Analytics.track('candidate', 'Reject Candidates', {
					candidates: selectedCandidates,
				});
				if (response.data?.content?.success.length > 0) {
					setConfirmModal({
						show: true,
						message: 'Candidato(s) declinado(s) con éxito.',
						icon: HappyFaceSvg,
						onClose: handleCloseRejectModal,
					});
				}
			}
		} catch (error: any) {
			Analytics.track('candidate', 'Error Reject Candidates', {
				candidates: selectedCandidates,
			});
			setConfirmModal({
				show: true,
				message: 'Hubo un error, candidato(s) no pudo ser declinado(s).',
				icon: SadFaceSvg,
				onClose: handleCloseRejectModal,
			});
		}
		setLoadingRejectCandidate(false);
	};

	return {
		handleRejectCandidates,
		confirmModal,
		isLoadingRejectCandidate,
	};
};
